import { MenuCategoryDto } from './menuCategory.dto';
import { MenuHoursDto } from './menuHours.dto';
import { MenuMenuCategoryDto } from './menuMenuCategory.dto';
import { MerchantDto } from './merchant.dto';

export class MerchantMenuDto {
  id: number;
  merchantId: number;
  name: string;
  startDate: Date;
  endDate?: Date;
  menuHours: MenuHoursDto[];
  merchant: MerchantDto;
  menuMenuCategories?: MenuMenuCategoryDto[];
  menuCategories?: MenuCategoryDto[]; // BD-2366 - Original property now mapped from the above - Do not delete!!
  // BD-2540
  isWebOrdering: boolean;
  isUltraOrder: boolean;
  isUrlAccessible: boolean;
  isKiosk: boolean;
  isPOS: boolean;
  isCatering?: boolean;
  online?: boolean;
  isDefaultPOSMenu: boolean;
  sequence?: number;
  isOrderAtTable?: boolean;
  priceBracketId?: number;
}
